import { App } from 'vue'
import { maska } from 'maska'

export default {
  install(app: App<Element>): any {
    app.directive('maska', maska)
  }
}
